// extracted by mini-css-extract-plugin
module.exports = {"or":"UserAddForm_or_1zRQm"};